<template>
    <div>
        <router-view/>
    </div>
</template>

<script>

    export default {
        name: 'App',
        components: {},

        mounted() {
            // const token = localStorage.getItem('token');
            // console.log("检测登录：" + token);
            // if (token) {
            //     this.$router.replace("/pages/index/index");
            // }

        }
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        overflow: hidden;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        height: 100vh;
    }

    /* iPad 适配样式 */
    @media (max-width: 1024px) {
        html, body {
            font-size: 14px;
        }

        /* 全局表格样式优化 */
        .el-table {
            font-size: 13px;
        }

        .el-table th,
        .el-table td {
            padding: 8px 4px;
        }

        /* 分页组件优化 */
        .el-pagination {
            padding: 10px 5px;
        }

        .el-pagination .el-select .el-input {
            width: 100px;
        }

        /* 按钮尺寸优化 */
        .el-button {
            padding: 8px 15px;
            font-size: 13px;
        }

        /* 表单元素优化 */
        .el-input__inner {
            height: 36px;
            line-height: 36px;
        }

        /* 对话框优化 */
        .el-dialog {
            width: 90% !important;
            margin: 5% auto !important;
        }
    }
</style>
